export default class BlockGallerySlider {
	static init() {
		let swipers = document.querySelectorAll('.block-gallery-swiper');

		swipers.forEach( (swiper) => {
			const prev = swiper.querySelector(".swiper-custom-button-prev");
			const next = swiper.querySelector(".swiper-custom-button-next");
			const swiperElement = new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				loop: true,
				init: false,
				navigation: {
					prevEl: prev,
					nextEl: next
				}
			});

			// // Recalculer le décalage après le premier chargement
			swiperElement.on('init', (s) => {
				let activeIndex = s.activeIndex;
				let slides = swiper.querySelectorAll(".swiper-slide");

				slides.forEach((slide, index) => {
					// Calculer la distance par rapport à la slide active
					let distance = Math.abs(index - activeIndex);

					if (distance === 0) {
						slide.style.transform = "translateY(0)"; // Slide active, pas de décalage
					} else if (distance % 2 === 1) {
						slide.style.transform = "translateY(-"+ this.pxToRem(60) +")"; // Décalage vers le haut pour chaque 2ème slide avant ou après
					} else {
						slide.style.transform = "translateY(0)"; // Les autres slides sans décalage
					}
				});
			});
			//
			// swiperElement.on('slideChangeTransitionStart', function (s) {
			// 	let activeIndex = s.activeIndex;
			// 	let slides = swiper.querySelectorAll(".swiper-slide");
			//
			// 	slides.forEach((slide, index) => {
			// 		// Calculer la distance par rapport à la slide active
			// 		let distance = Math.abs(index - activeIndex);
			//
			// 		if (distance === 0) {
			// 			slide.style.transform = "translateY(0)"; // Slide active, pas de décalage
			// 		} else if (distance % 2 === 1) {
			// 			slide.style.transform = "translateY(-60px)"; // Décalage vers le haut pour chaque 2ème slide avant ou après
			// 		} else {
			// 			slide.style.transform = "translateY(0)"; // Les autres slides sans décalage
			// 		}
			// 	});
			// });
			//
			// // Initialisation de Swiper
			swiperElement.init();

		});
	}

	static pxToRem(px){
		// const remCalc = (px: number | string, base: number = 16) => {
		const tempPx = `${px}`.replace('px', '')

		return (1 / 15) * parseInt(tempPx) + 'rem';
	}

}
